<!--按时间批量添加班次-->
<template>
  <el-dialog
    ref="planAdd"
    :close-on-click-modal="false"
    title="按时间批量添加班次"
    :visible.sync="visible"
    :append-to-body="true"
    width="60%"
    :before-close="handleClose"
  >
    <el-form ref="planForm" :model="planForm" size="small">
      <div class="tipsBox">
        <img style="width: 20px; height: 20px" src="./static/tips.png" />
        <span>选择当日运营起始时间，输入每个班次的间隔发班时间后点击“生成”！</span>
      </div>
      <el-row :gutter="24">
        <el-col :span="5">
          <el-time-picker
            v-model="start"
            value-format="HH:mm"
            format="HH:mm"
            size="small"
            :picker-options="{
              selectableRange: `00:00:00 - ${end ? end + ':00' : '23:59:00'}`
            }"
            placeholder="选择起始时间"
          />
        </el-col>
        <el-col :span="5">
          <el-time-picker
            v-model="end"
            value-format="HH:mm"
            format="HH:mm"
            size="small"
            :picker-options="{
              selectableRange: `${start ? start + ':00' : '00:00:00'} - 23:59:00`
            }"
            placeholder="选择结束时间"
          />
        </el-col>

        <el-col :span="6">
          <avue-input-number
            v-model="step"
            :minRows="0"
            :maxRows="120"
            style="width: 8vw"
            size="small"
          />
          <span>分钟/班</span>
        </el-col>

        <el-col :span="4">
          <el-button type="primary" size="small" @click="createTimes">生成</el-button>
        </el-col>
      </el-row>
      <el-form-item label="班次时间:">
        <span v-for="(item, index) of planForm.times" :key="index" style="padding: 2px">
          <el-tag type="primary" size="small" plain closable @close="deleteTime(index)">
            {{ item.value }}
          </el-tag>
        </span>
      </el-form-item>
      <el-form-item label="价格方案：" />
      <div class="tipsBox">
        <img style="width: 20px; height: 20px" src="./static/tips.png" />
        <span>根据班次、价格等选择班次的价格方案！</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="9">
          <avue-select
            placeholder="请选择价格方案"
            v-model="planForm.priceMethodId"
            :dic="priceMthodItems"
            :props="{ label: 'priceMethodName', value: 'priceMethodId' }"
            size="small"
            @change="handlePricemethod"
            style="width: 20vw"
          />
        </el-col>
        <el-col :span="3">
          <el-button type="text" @click="selePrice">
            <span style="font-size: 14px">改价</span>
          </el-button>
        </el-col>
      </el-row>
      <el-form-item label="站点设置：">
        <span style="margin-right: 15px">{{ planForm.stationNameGroup }}</span>
        <!-- <el-button type="text" @click="seleStation"><span style="font-size:14px;">设置</span></el-button> -->
      </el-form-item>
      <el-form-item label="司机车辆信息：">
        <!-- <span style="margin-right: 15px">{{ driverInfo }}</span> -->
        <!-- <el-button type="text" @click="seleDriver"
          ><span style="font-size: 14px">设置</span></el-button
        > -->
        <el-transfer
          ref="transfer"
          filterable
          filter-placeholder="请输入搜索内容"
          v-model="selectedList"
          :data="driverList"
          :titles="['司机', '已选中司机']"
          target-order="push"
          :render-content="renderContent"
        />
      </el-form-item>
      <el-form-item label="标签：">
        <el-popover placement="bottom" width="160" trigger="manual" v-model="labelVisible">
          <div style="padding: 0px 0px 20px 20px; max-height: 200px; overflow-y: scroll">
            <el-checkbox-group :max="2" v-model="labelCheck">
              <div
                v-for="item in labelList"
                :key="item.label"
                style="display: flex; justify-content: space-between; align-items: center"
              >
                <el-checkbox :label="item.type">{{ item.name }}</el-checkbox>
                <el-button
                  size="mini"
                  type="text"
                  icon="el-icon-edit"
                  v-has-permi="['edit_label']"
                  @click="handleAdd(item, 'edit')"
                >
                  编辑
                </el-button>
              </div>
            </el-checkbox-group>
          </div>
          <div class="flex flex-justify-between">
            <div>
              <el-button
                size="mini"
                type="text"
                v-has-permi="['add_label']"
                @click="handleAdd({}, 'add')"
              >
                添加
              </el-button>
            </div>
            <div>
              <el-button size="mini" type="text" @click="labelVisible = false">取消</el-button>
              <el-button type="primary" size="mini" @click="submitLabel()">确定</el-button>
            </div>
          </div>
          <el-button slot="reference" type="text" class="add-labels" @click="addLabels">
            添加
          </el-button>
        </el-popover>
        <span>
          <el-tag
            v-for="(item, index) in labels"
            :key="index"
            closable
            type="warning"
            size="small"
            style="margin-right: 5px"
            @close="handleCloseLabel(index)"
          >
            {{ labelList.filter((it) => +it.id === item)[0].name }}
          </el-tag>
        </span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="cancel">取 消</el-button>
      <el-button type="primary" size="small" @click="save">保存</el-button>
    </div>
    <price-view v-if="changePriceShow" ref="priceview" @revisePriceInfo="revisePriceInfo" />
    <set-station v-if="setStationShowDialog" ref="setStation" @LineFormData="handleLineFormData" />
    <set-driver v-if="seleDriverShow" ref="driverinfo" @DriverFormData="DriverFormData" />
    <AddLabel ref="addLabel" @close="$emit('addLabelClose')" />
  </el-dialog>
</template>

<script>
  import setStation from './set-station'
  import SetDriver from './set-driver'
  import priceView from './price-view'
  import {
    priceSchemeList,
    getStationRule,
    getDriver,
    getSelectedDriver,
    saveSelectedDriver
  } from '@/api/transport/bustime'
  import { getPriceDetail } from '@/api/transport/pricescheme'
  import { uuidv5 } from '@/util/util'
  import useHandleLabel from './hooks/useLabel.js'
  import AddLabel from './add-label.vue'
  import Sortable from 'sortablejs'

  const parseTime = function (time) {
    const values = (time || '').split(':')
    if (values.length >= 2) {
      const hours = parseInt(values[0], 10)
      const minutes = parseInt(values[1], 10)
      return {
        hours,
        minutes
      }
    }
    return null
  }
  const compareTime = function (time1, time2) {
    const value1 = parseTime(time1)
    const value2 = parseTime(time2)
    const minutes1 = value1.minutes + value1.hours * 60
    const minutes2 = value2.minutes + value2.hours * 60
    if (minutes1 === minutes2) {
      return 0
    }
    return minutes1 > minutes2 ? 1 : -1
  }
  const formatTime = function (time) {
    return (
      (time.hours < 10 ? '0' + time.hours : time.hours) +
      ':' +
      (time.minutes < 10 ? '0' + time.minutes : time.minutes)
    )
  }
  const nextTime = function (time, step) {
    const timeValue = parseTime(time)
    const stepValue = parseTime(step)
    const next = {
      hours: timeValue.hours,
      minutes: timeValue.minutes
    }
    next.minutes += stepValue.minutes
    next.hours += stepValue.hours
    next.hours += Math.floor(next.minutes / 60)
    next.minutes = next.minutes % 60
    return formatTime(next)
  }
  export default {
    name: 'batchRunningplan',
    props: {
      labelList: {
        type: Array,
        default: () => []
      }
    },
    components: {
      setStation,
      SetDriver,
      priceView,
      AddLabel
    },
    data() {
      return {
        labelCheckFlag: false,
        title: '',
        visible: true,
        setStationShowDialog: false, // 设置站点规则弹窗
        changePriceShow: false, // 改价弹窗
        seleDriverShow: false, // 选择司机车辆信息弹窗
        driverCarInfo: {}, // 司机车辆信息
        driverInfo: '',
        carTypeDisabled: true,
        lineId: 0,
        merchantId: 0,
        carSeatDic: [], // 车座
        carTypeDic: [], // 车型
        deepCarTypeDic: [],
        priceMethodDic: [], // 价格方案
        seats: null,
        planForm: {
          // 班次表单
          times: [], // 班次时间
          stationNameGroup: '',
          isnew: false,
          stationRule: '',
          carId: '',
          carType: '',
          carTypeStr: '',
          carSeat: '',
          carSeatStr: '',
          departureTime: '',
          driverId: '',
          driverInfo: '',
          priceMethodId: '',
          pricemethodStr: '',
          stationConfigVos: [],
          stationRuleId: ''
        },
        obejectFrom: [], // 表单对象
        start: '00:00',
        end: '23:59',
        step: 30,
        stationRuleList: [],
        selectiondAll: {
          // 选中所有数据
          stationNameGroup: '',
          stationName: '', // 站点名称
          data: [] // 站点数据
        },
        labelVisible: false,
        labels: [],
        labelCheck: [],
        selectedList: [],
        driverList: []
      }
    },
    computed: {
      items() {
        const start = this.start
        const end = this.end
        const step = `00:${this.step}`
        const result = []
        if (start && end && step) {
          let current = start
          while (compareTime(current, end) <= 0) {
            result.push({
              value: current
            })
            current = nextTime(current, step)
          }
        }
        return result
      },
      carTypeItems: {
        get() {
          return this.$store.state.customtrans.carTypeList
        },
        set(val) {
          this.$store.commit('UPDATE_CAR_TYPE_LIST', val)
        }
      },
      priceMthodItems: {
        get() {
          return this.$store.state.customtrans.priceMethodSelect
        },
        set(val) {
          this.$store.commit('UPDATE_PRICE_METHOD_LIST', val)
        }
      }
    },
    setup() {
      const { getLabelName } = useHandleLabel()
      return {
        getLabelName
      }
    },
    mounted() {
      this.$nextTick(() => {
        const transfer = this.$refs.transfer.$el
        const rightPanel = transfer
          .getElementsByClassName('el-transfer-panel')[1]
          .getElementsByClassName('el-transfer-panel__body')[0]
        const rightEl = rightPanel.getElementsByClassName('el-transfer-panel__list')[0]
        Sortable.create(rightEl, {
          onEnd: (evt) => {
            const { oldIndex, newIndex } = evt
            const _arr = this.selectedList.splice(oldIndex, 1)
            this.selectedList.splice(newIndex, 0, _arr[0])
          }
        })
      })
    },
    watch: {
      // labelCheck: {
      //   handler(newVal) {
      //     if (newVal.length > 1) {
      //       console.log('newVal', newVal, this.labelList)
      //       const nameList = []
      //       const list = []
      //       newVal.forEach((id) => {
      //         this.labelList.forEach((item) => {
      //           if (id === parseInt(item.id)) {
      //             list.push(item)
      //           }
      //         })
      //       })
      //       list.forEach((item) => {
      //         if (item.position === 1) {
      //           nameList.push(item.name)
      //         }
      //       })
      //       if (nameList.length > 1) {
      //         this.labelCheckFlag = true
      //         this.$message.error(`只能选择一个标签置顶，当前${nameList.join('、')}标签选择了置顶`)
      //       } else {
      //         this.labelCheckFlag = false
      //       }
      //     } else {
      //       this.labelCheckFlag = false
      //     }
      //   },
      //   deep: true
      // },
      selectedList: {
        handler() {
          this.$nextTick(() => {
            const transfer = this.$refs.transfer.$el
            const leftPanel = transfer
              .getElementsByClassName('el-transfer-panel')[0]
              .getElementsByClassName('el-transfer-panel__body')[0]
              .getElementsByClassName('drag-icon')
            for (let i = 0; i < leftPanel.length; i++) {
              leftPanel[i].style.display = 'none'
            }
          })
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      submitLabel(index) {
        this.labels = this.labelCheck
        console.log(this.labels)
        this.labelVisible = false
      },
      addLabels() {
        this.labelVisible = !this.labelVisible
        this.$emit('addLabelClose')
      },
      handleCloseLabel(index) {
        this.labels.splice(index, 1)
      },
      init(row) {
        this.visible = true
        this.lineId = row.lineId
        this.merchantId = row.merchantId
        this.carTypeDisabled = true
        this.$nextTick(() => {
          this.$set(this.planForm, 'topLableIds', [])
          this.stationRuleList = []
          this.planForm.stationNameGroup = ''
          this.selectiondAll.stationName = ''
          this.$store.commit('REMOVE_PRICE_METHOD_LIST')
          if (this.carSeatDic && this.carTypeDic) {
            this.getPriceMethodList({ lineId: this.lineId, merchantId: this.merchantId })
          }
          // 站点规则
          this.getStationRule(this.lineId, this.merchantId)
        })
      },
      deleteTime(index) {
        this.planForm.times.splice(index, 1)
      },
      // 改价
      selePrice() {
        if (!this.planForm.priceMethodId) {
          this.$message.warning('请先选择价格方案')
          return
        }
        const item = {
          index: -1,
          flightPriceMethodTypes: this.planForm.flightPriceMethodTypes
        }
        console.log('this.planForm.flightPriceMethodTypes', item)
        this.changePriceShow = true
        this.$nextTick(() => {
          const row = JSON.stringify(item)
          this.$refs.priceview.init(row)
        })
      },
      // 改价回显
      revisePriceInfo(val) {
        this.planForm.flightPriceMethodTypes = val.flightPriceMethodTypes
        this.$message.success('修改成功')
      },
      // 设置站点规则
      seleStation() {
        this.setStationShowDialog = true
        this.$nextTick(() => {
          const row = {
            lineId: this.lineId,
            merchantId: this.merchantId
          }
          this.$refs.setStation.init(row)
        })
      },
      // 设置司机车辆信息
      seleDriver() {
        if (!this.planForm.priceMethodId) {
          this.$message.warning('请先选择价格方案')
          return
        }
        this.seleDriverShow = true
        this.$nextTick(() => {
          this.$refs.driverinfo.init(9999, this.planForm.priceMethodId, this.merchantId)
        })
      },
      // 司机车辆信息
      DriverFormData(val) {
        this.driverInfo = val.driverInfo
        this.driverCarInfo = val
      },
      handleStartTime(val) {
        if (val !== null) {
          this.start = val.toString()
        }
      },
      handleEndTime(val) {
        if (val !== null) {
          this.end = val.toString()
        }
      },
      createTimes() {
        if (this.start === null) {
          this.$message.error('开始时间不能为空')
          return
        }
        if (this.end === null) {
          this.$message.error('结束时间不能为空')
          return
        }
        this.planForm.times = this.items
      },
      // 下拉获取车型
      // handleSeateNumSelect(val) {
      //   this.carTypeDisabled = false
      //   this.$store.commit('REMOVE_CAR_TYPE_LIST')
      //   this.seats = val
      //   getSeatNumSelect(val).then(resp => {
      //     const list = resp.data
      //     list.map(item => {
      //       this.$store.commit('ADD_CAR_TYPE_LIST', item)
      //     })
      //   })
      //   if (val) {
      //     // 获取下拉的label
      //     let onData = {}
      //     onData = this.carSeatDic.find((item) => {
      //       return item.seats === val
      //     })
      //     this.planForm.carSeatStr = onData.seatName
      //   }
      // },
      // handleCartypeSelect(val) {
      //   this.$store.commit('REMOVE_PRICE_METHOD_LIST')
      //   const params = {
      //     current: 1,
      //     size: 9999,
      //     lineId: this.lineId,
      //     merchantId: this.merchantId,
      //     seats: this.seats === null ? '' : this.seats,
      //     type: val
      //   }
      //   this.getPriceMethodList(params)
      //   if (val) {
      //     // 获取下拉的label
      //     let onData = {}
      //     onData = this.carTypeItems.find((item) => {
      //       return item.type === val
      //     })
      //     this.planForm.carTypeStr = onData.carType
      //   }
      // },
      handlePricemethod(val) {
        this.driverInfo = ''
        if (val) {
          let onData = {}
          onData = this.priceMthodItems.find((item) => {
            return item.priceMethodId === val
          })
          this.planForm.pricemethodStr = onData.priceMethodName
          this.getPriceInfo(val)
          this.getDriverInfo(val)
          this.getSelected()
          return
        }
        this.driverList = []
        this.selectedList = []
      },
      // 获取价格方案详情
      getPriceInfo(id) {
        getPriceDetail(id).then((resp) => {
          this.planForm.flightPriceMethodTypes = resp.data
        })
      },
      // 选择站点规则回显
      handleLineFormData(data) {
        if (data) {
          this.planForm.stationNameGroup = data.stationNameGroup
          this.planForm.stationConfigVos = data.data
        }
      },
      async save() {
        if (this.planForm.times.length === 0) {
          this.$message.error('请设置班次时间')
          return
        }
        if (this.planForm.priceMethodId === '') {
          this.$message.error('请选择价格方案')
          return
        }
        if (!this.selectedList.length) {
          this.$message.error('请设置车辆信息')
          return
        }
        let selectedDriver = []
        this.selectedList.forEach((it) => {
          selectedDriver = selectedDriver.concat(this.driverList.filter((v) => v.driverId === it))
        })

        selectedDriver.forEach((it, i) => {
          it.lineId = this.lineId
          it.merchantId = this.merchantId
          it.sort = i + 1
        })
        const { code } = await saveSelectedDriver(selectedDriver)
        if (code !== 0) {
          return
        }

        const n = Math.ceil(this.planForm.times.length / selectedDriver.length)
        const arr = []
        for (let i = 0; i < n; i++) {
          arr[i] = selectedDriver
        }
        const result = arr.flat(1)
        const list = []
        // selectedDriver.forEach((it) => {
        this.planForm.times.forEach((item, index) => {
          const params = {
            labelCheck: this.labels,
            stationNameGroup: this.planForm.stationNameGroup,
            carId: result[index].carId,
            carType: this.planForm.carType === '' ? '' : this.planForm.carType,
            carSeat: this.planForm.carSeat === '' ? '' : this.planForm.carSeat,
            departureTime: item.value,
            carSeatName: this.planForm.carSeatStr || '',
            carTypeName: this.planForm.carTypeStr || '',
            priceMethodName: this.planForm.pricemethodStr,
            flightPriceMethodTypes: this.planForm.flightPriceMethodTypes,
            driverId: result[index].driverId,
            driverInfo: result[index].driverName + ' ' + result[index].driverPhone,
            priceMethodId: this.planForm.priceMethodId === '' ? '' : this.planForm.priceMethodId,
            stationConfigVos: (() =>
              this.planForm.stationConfigVos.length === 0 ? [] : this.planForm.stationConfigVos)(),
            uuid: uuidv5(),
            labelVisible: false
          }
          if (this.labels && this.labels.length !== 0) {
            params.topLableIds = this.planForm.topLableIds.map((item) => {
              return {
                ...item,
                uuid: uuidv5()
              }
            })

            params.labelList = []
            this.labels.forEach((item) => {
              params.labelList.push({
                id: item,
                uuid: uuidv5()
              })
            })
          }
          list.push(params)
        })
        // })
        this.obejectFrom = list
        // this.$store.commit('REMOVE_RUNNING_PLAN_FORM')
        this.$store.commit('REMOVE_PRICE_METHOD_LIST')
        this.$store.commit('REMOVE_CAR_TYPE_LIST')
        this.$emit('batchPlanTime', this.obejectFrom)
        this.planForm.carType = ''
        this.planForm.carSeat = ''
        this.planForm.priceMethodId = ''
        this.planForm.times = ''
        this.planForm.stationNameGroup = ''
        this.visible = false
      },
      cancel() {
        this.planForm.carType = ''
        this.planForm.carSeat = ''
        this.planForm.priceMethodId = ''
        this.planForm.times = ''
        this.planForm.stationNameGroup = ''
        this.selectiondAll.stationName = ''
        this.planForm.times = ''
        this.priceMthodItems = []
        this.stationRuleList = []
        this.visible = false
        this.labelVisible = false
      },
      handleClose(done) {
        this.planForm.times = ''
        this.planForm.stationNameGroup = ''
        this.selectiondAll.stationName = ''
        this.planForm.priceMethodId = ''
        this.priceMthodItems = []
        this.stationRuleList = []
        done()

        this.labelVisible = false
        this.driverList = []
        this.selectedList = []
      },
      // 获取价格方案
      getPriceMethodList(params = {}) {
        priceSchemeList(params).then((resp) => {
          // this.priceMethodDic = resp.data
          const list = resp.data
          // eslint-disable-next-line array-callback-return
          list.map((item) => {
            this.$store.commit('ADD_PRICE_METHOD_LIST', item)
          })
        })
      },
      // 查询站点规则
      async getStationRule(lineId, merchantId) {
        const params = {
          current: 1,
          lineId,
          merchantId,
          size: 9999
        }
        await getStationRule(params).then((resp) => {
          const list = resp.data
          if (list) {
            list.forEach((item, index) => {
              const fields = {
                index,
                stationId: item.stationId,
                stationName: item.stationName,
                rule: item.rule,
                stationRuleId: Number.parseInt(item.stationRuleId),
                startSellTime: item.startSellTime,
                endSellTime: item.endSellTime,
                isOpen: item.isOpen,
                openPickUp: item.openPickUp,
                pickUpRule: item.pickUpRule,
                pickUpTime: item.pickUpTime,
                pickUpType: item.pickUpType,
                sort: item.sort
              }
              this.stationRuleList.push(fields)
            })
          }
          this.stationRuleList
            .filter((p) => p.isOpen === 1)
            .forEach((item) => {
              this.selectiondAll.stationName += item.stationName + '-'
            })

          this.planForm.stationNameGroup =
            `${this.stationRuleList.filter((p) => p.isOpen === 1).length} 个站点：` +
            this.selectiondAll.stationName.substring(
              0,
              this.selectiondAll.stationName.lastIndexOf('-')
            )
          this.planForm.stationConfigVos = this.stationRuleList
        })
      },
      handleAdd(row, type) {
        this.$refs.addLabel.init(row, type)
      },
      renderContent(h, option) {
        return (
          <div class="position-relative flex flex-align-center">
            <el-tooltip class="item" effect="dark" placement="top">
              <span slot="content">{option.label}</span>
              <span style="display: inline-block; width: 110px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-left: 10px">
                {option.label}
              </span>
            </el-tooltip>
            <i class="el-icon-s-grid margin-left-20 drag-icon"></i>
          </div>
        )
      },
      // 获取司机信息
      async getDriverInfo(v) {
        const { code, data } = await getDriver({
          current: 1,
          lineId: this.lineId,
          merchantId: this.merchantId,
          priceMethodId: v,
          size: 1000
        })
        if (code !== 0) {
          return
        }
        if (!data || !Array.isArray(data.records)) {
          return
        }
        data.records.forEach((it) => {
          it.key = it.driverId
          it.label = it.driverName + ' ' + it.driverPhone
        })
        this.driverList = data.records
        this.$nextTick(() => {
          const transfer = this.$refs.transfer.$el
          const leftPanel = transfer
            .getElementsByClassName('el-transfer-panel')[0]
            .getElementsByClassName('el-transfer-panel__body')[0]
            .getElementsByClassName('drag-icon')
          for (let i = 0; i < leftPanel.length; i++) {
            leftPanel[i].style.display = 'none'
          }
        })
      },
      // 获取线路司机排序
      async getSelected() {
        const { code, data } = await getSelectedDriver({
          lineId: this.lineId,
          merchantId: this.merchantId
        })
        if (code !== 0 || !Array.isArray(data)) {
          return
        }
        const arr = []
        data.forEach((it) => {
          arr.push(it.driverId)
        })
        this.selectedList = arr
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tipsBox {
    display: flex;
    align-items: center;
    margin: 0 0 10px 5px;
    font-size: 13px;
    color: #9f9f9f;
  }
  .tipsBox span {
    margin-left: 5px;
  }
  ::v-deep .el-date-editor.el-input {
    width: 10vw;
  }
  .add-labels {
    color: #e6a23c;
    text-decoration: underline;
    margin-right: 10px;
    cursor: pointer;
  }
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::v-deep .el-transfer {
    justify-content: flex-start;
    align-items: center;
  }
  ::v-deep .el-transfer-panel__item {
    margin: 0 !important;
    padding: 0 !important;
  }
  ::v-deep .el-checkbox__input {
    padding-left: 10px !important;
  }
</style>
